var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-spacer'), _vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value,
      icon = _ref.icon,
      items = _ref.items,
      multiple = _ref.multiple,
      clearable = _ref.clearable;
    return _c('v-col', {
      key: value,
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-card', _vm._b({
      attrs: {
        "flat": ""
      }
    }, 'v-card', {
      loading: _vm.loading
    }, false), [_c('v-select', _vm._b({
      key: value,
      staticClass: "v-input--large w-lg-240px",
      attrs: {
        "placeholder": text,
        "prepend-inner-icon": icon,
        "hide-details": "",
        "outlined": ""
      },
      on: {
        "change": _vm.push
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function (_ref2) {
          var _vm$query$value, _vm$query$value$inclu;
          var item = _ref2.item;
          return [_c('v-list-item', {
            on: {
              "click": function ($event) {
                return _vm.setFilter({
                  key: value,
                  value: item.value,
                  multiple
                });
              }
            }
          }, [_c('v-list-item-icon', [_c('v-simple-checkbox', {
            attrs: {
              "value": multiple ? (_vm$query$value = _vm.query[value]) === null || _vm$query$value === void 0 ? void 0 : (_vm$query$value$inclu = _vm$query$value.includes) === null || _vm$query$value$inclu === void 0 ? void 0 : _vm$query$value$inclu.call(_vm$query$value, item.value) : _vm.query[value] == item.value,
              "color": "primary"
            },
            on: {
              "click": function ($event) {
                return _vm.setFilter({
                  key: value,
                  value: item.value,
                  multiple
                });
              }
            }
          })], 1), _c('v-list-item-title', [_c('p', {
            staticClass: "page-text grey-9--text"
          }, [_vm._v(_vm._s(item.text))])])], 1)];
        }
      }], null, true),
      model: {
        value: _vm.query[value],
        callback: function ($$v) {
          _vm.$set(_vm.query, value, $$v);
        },
        expression: "query[value]"
      }
    }, 'v-select', {
      items,
      multiple,
      clearable
    }, false))], 1)], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }